// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2JlPp","filesListContainer":"PosDisputesFiles_filesListContainer__2s8Hy","filesButton":"PosDisputesFiles_filesButton__3gFCW"};